import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

class Carousel {
  constructor() {
    this.swiperElements = document.querySelectorAll('[data-carousel]');

    if (this.swiperElements != null && this.swiperElements.length > 0) {
      this.swiperElements.forEach((swiperElement) => {
        // swiper errors if there isn't a min number for looping
        const CAN_LOOP = swiperElement.querySelectorAll('.swiper-slide').length > 3;

        new Swiper(swiperElement, {
          modules: [Navigation, Pagination],
          loop: CAN_LOOP,
          slidesPerView: 1,
          spaceBetween: 12,

          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
          },

          pagination: {
            el: swiperElement.querySelector('.swiper-pagination'),
            clickable: true,
          },

          navigation: {
            nextEl: swiperElement.querySelector('.swiper-button-next'),
            prevEl: swiperElement.querySelector('.swiper-button-prev'),
          },
        });
      });
    }
  }
}

export default Carousel;
